<div
    class="relative flex flex-0 items-center justify-start w-full px-0.5 z-49 border-t bg-card dark:bg-transparent print:hidden">
    <div class="font-medium text-sm text-secondary p-3 md:p-3"><a target="blank" href="https://dreamstep.in/">Dreamstep
            Software Innovations Pvt
            Ltd</a>. &copy; {{currentYear}}</div>
            
    <span class="example-spacer"></span>
    
     
    <div class="m-0.5" style="border-left: 1px solid #b9c0ca;border-right: 1px solid #b9c0ca;">
        <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
    </div>
    <div class="m-0.5" style="border-right: 1px solid #b9c0ca;">
        <shortcuts></shortcuts>
   </div>
    <div style="border-right: 1px solid #b9c0ca;" *ngIf="pgeRvwData">
        <!-- <button mat-icon-button [matTooltip]="'Post Review'" (click)="shwReview()">
            <mat-icon [svgIcon]="'heroicons_outline:thumb-up'" style=" vertical-align: middle;"></mat-icon>
        </button> -->
        <app-reviews  [rvwData]="pgeRvwData"></app-reviews>
    </div>
    <div class="p-2" style="border-right: 1px solid #b9c0ca;">
        <button mat-icon-button [matTooltip]="'Help'">
            <mat-icon [svgIcon]="'heroicons_outline:question-mark-circle'" style=" vertical-align: middle;"></mat-icon>
        </button>
    </div>
</div>